import OptionalTimePicker from "components/OptionalTimePicker";
import React from "react";
import { parseFromTimeString } from "utilities/momentutils";
import { FreefieldInPageEditInputProps } from "../models";

const FFInPageEditOptionalTimePicker = (props: FreefieldInPageEditInputProps) => {
  const [value, setValue] = React.useState(props.value ? parseFromTimeString(props.value) : undefined);

  const onChange = (newValue: moment.Moment, submit: boolean) => {
    setValue(newValue);
    props.onChange(newValue?.format("HH:mm"), submit);
  };

  return <OptionalTimePicker
    autoFocus
    value={value}
    onChange={onChange}
  />;
};

export default FFInPageEditOptionalTimePicker;